import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './scss/_flaticon.scss';
import './scss/style.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

import $ from 'jquery';
if ($) {
  const bootstrap = require('bootstrap/dist/js/bootstrap.bundle.min');
  window.jQuery = window.$ = $;
  window.bootstrap = bootstrap;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <App />
  </HashRouter>
  // <React.StrictMode>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
